import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../domain';
import {X9ContentStateStore} from './common/X9ContentStateStore';
import {TeacherFlashcards} from './flashcard/classroom/TeacherFlashcards';
import {TeacherGapFilling} from './gap-filling/classroom/teacher/TeacherGapFilling';
import {TeacherGroupingExercise} from './grouping-exercise/classroom/TeacherGroupingExercise';
import {TeacherMatchingQuestion} from './matching-question/classroom/teacher/TeacherMatchingQuestion';
import {TeacherMcq} from './mcq/classroom/teacher/TeacherMcq';
import {TeacherOpenEndedQuestionInline} from './open-ended-question-inline/classroom/TeacherOpenEndedQuestionInline';
import {TeacherOpenEndedQuestion} from './open-ended-question/classroom/TeacherOpenEndedQuestion';
import {TeacherSelectQuestion} from './select-question/classroom/TeacherSelectQuestion';
import {TeacherSlideShow} from './slideshow/classroom/TeacherSlideShow';
import {X9StaticHtmlView} from './static-html/X9StaticHtmlView';
import {X9StaticImageView} from './static-image/X9StaticImageView';
import {TeacherSyncedAudio} from './synced-audio/classroom/teacher/TeacherSyncedAudio';
import {TeacherSyncedVideo} from './synced-video/classroom/teacher/TeacherSyncedVideo';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore;
}

export class X9TeacherComponent extends React.Component<Props> {

  render() {
    const {x9, store} = this.props;

    switch (x9.ContentType) {
      case 'static-html':
        return <X9StaticHtmlView x9={x9}/>;
      case 'static-image':
        return <X9StaticImageView x9={x9}/>;
      case 'matching-question':
        return (<TeacherMatchingQuestion x9={x9} store={store}/>);
      case 'select-question':
        return (<TeacherSelectQuestion x9={x9} store={store}/>);
      case 'gap-filling':
        return (<TeacherGapFilling x9={x9} store={store}/>);
      case 'multiple-choice-question':
        return (<TeacherMcq x9={x9} store={store}/>);
      case 'grouping-exercise':
        return (<TeacherGroupingExercise x9={x9} store={store}/>);
      case 'flashcards':
        return (<TeacherFlashcards x9={x9} store={store}/>);
      case 'slideshow':
        return (<TeacherSlideShow x9={x9} store={store}/>);
      case 'open-ended-question':
        return (<TeacherOpenEndedQuestion x9={x9} store={store}/>);
      case 'open-ended-question-inline':
        return (<TeacherOpenEndedQuestionInline x9={x9} store={store}/>);
      case 'synced-audio':
        return (<TeacherSyncedAudio x9={x9} store={store}/>);
      case 'synced-video':
        return (<TeacherSyncedVideo x9={x9} store={store}/>);
    }
    return null;
  }
}
